<div class="breadcrumb-container {{ invertColor ? 'invert' : '' }} ">
  <div class="content">
    <div *ngFor="let breadcrumb of breadcrumbs$ | async as breadcrumbs; let i = index" class="breadcrumb">
      <a *ngIf="breadcrumb.link && i !== breadcrumbs.length - 1; else noLink"
         [class]="i == 0 ? 'link first-link': 'link'"
         [customRouterLink]="breadcrumb.link">
        {{ breadcrumb.link.title }}</a>
      <ng-template #noLink>
        <div *ngIf="breadcrumb.link" class="link no-link">
          {{ breadcrumb.link.title }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
